module.exports = __webpack_public_path__ + "static/media/cheese-swiss.7a8aafa1.svg";